import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import ServiceIcon from "../components/ServiceIcon";
import { SERVICES, PRICING } from "../lib/data";

export default function Services() {
  return (
    <>
      <Seo title="Physiotherapy Services" description="Sports injuries, back & neck pain, shoulder & knee pain, post-op rehab, WorkCover, NDIS, dry needling and exercise rehabilitation in Melbourne." path="/services" />
      <PageHeader
        eyebrow="Our Services"
        title="Specialist physiotherapy for every stage of recovery"
        subtitle="From acute injuries to long-term rehabilitation, we provide evidence-based care tailored to your goals."
      />

      {/* PRICING */}
      <section className="py-20 sm:py-28" data-testid="pricing-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
          <Reveal>
            <div className="max-w-2xl">
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-navy">Pricing</span>
              <h2 className="mt-4 font-display text-3xl sm:text-4xl font-semibold text-text-dark tracking-tight">Simple, transparent fees</h2>
            </div>
          </Reveal>
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {PRICING.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.08}>
                <div className="h-full bg-white rounded-3xl border border-border-light p-8 flex flex-col card-hover" data-testid={`pricing-${p.id}`}>
                  <span className="text-xs font-bold tracking-[0.15em] uppercase text-navy/60">{p.category}</span>
                  <h3 className="mt-3 font-display text-xl font-semibold text-text-dark">{p.name}</h3>
                  <p className="mt-2 text-sm text-text-muted flex-1">{p.description}</p>
                  <div className="mt-6 flex items-end justify-between">
                    <div>
                      <div className="font-display text-3xl font-bold text-navy">{p.price}</div>
                      <div className="text-sm text-text-muted">{p.duration}</div>
                    </div>
                    <Link to="/book" className="rounded-full bg-navy px-5 py-2.5 text-sm font-semibold text-white hover:bg-navy-hover transition-colors" data-testid={`pricing-book-${p.id}`}>Book</Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 sm:py-28 bg-offwhite">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s, i) => (
              <Reveal key={s.slug} delay={(i % 3) * 0.08}>
                <Link to={`/services/${s.slug}`} data-testid={`service-card-${s.slug}`} className="group block h-full bg-white rounded-3xl border border-border-light overflow-hidden card-hover">
                  <div className="h-44 overflow-hidden relative">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover img-zoom" />
                    <div className="absolute top-4 left-4 h-11 w-11 grid place-items-center rounded-xl bg-white/90 backdrop-blur text-navy">
                      <ServiceIcon name={s.icon} className="h-5 w-5" />
                    </div>
                  </div>
                  <div className="p-7">
                    <h3 className="font-display text-xl font-semibold text-text-dark">{s.title}</h3>
                    <p className="mt-2 text-text-muted leading-relaxed">{s.short}</p>
                    <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-navy">
                      Learn more <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
